/*import { Col } from "react-bootstrap";

export const ProjectCard = ({ title, description, imgUrl }) => {
  return (
    <Col size={12} sm={6} md={4}>
      <div className="proj-imgbx">
        <img src={imgUrl} />
        <div className="proj-txtx">
          <h4>{title}</h4>
          <span>{description}</span>
        </div>
      </div>
    </Col>
  )
}*/

import React from "react";
import { Col } from "react-bootstrap";

export const ProjectCard = ({ title, description, imgUrl, externalLink }) => {
  // Check if an external link is provided
  if (externalLink) {
    // If an external link is provided, use an anchor tag
    return (
      <Col size={12} sm={6} md={4}>
        <a href={externalLink} target="_blank" rel="noopener noreferrer">
          <div className="proj-imgbx">
            <img src={imgUrl} alt={title} />
            <div className="proj-txtx">
              <h4>{title}</h4>
              <span>{description}</span>
            </div>
          </div>
        </a>
      </Col>
    );
  }

  // If no external link is provided, just render the card
  return (
    <Col size={12} sm={6} md={4}>
      <div className="proj-imgbx">
        <img src={imgUrl} alt={title} />
        <div className="proj-txtx">
          <h4 style={{ color: 'white' }}>{title}</h4>
          <span style={{ color: 'white' }}>{description}</span>
        </div>
      </div>
    </Col>
  );
};


